<input
  type="checkbox"
  id="{{ switchId }}"
  name="{{ switchName }}"
  [hidden]="switchDisabled"
  [(ngModel)]="switchValue"
  (change)="triggerChange()"
/>
<span role="presentation">
  <span></span>
</span>
